export default {
  // BTC餘額
  btcBalance: "BTC餘額",
  updated: "更新",

  // 交易概況
  transactionOverview: "交易概況",
  cumulativeInOutAmount: "累計轉入&轉出數量",
  inOutTransactions: "轉入&轉出筆數",
  avgInOutAmount: "平均轉入&平均數量",
  firstTransactionTime: "首次交易時間",
};
